module.exports = __webpack_public_path__ + "static/media/booking.906fac8e.svg";